/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';
import { isInactive } from '../../resources/cs-master.model';

@Injectable()
export class CSMasterGridDefinition extends ManualGridDefinition {
  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      {
        field: 'name',
        headerName: this.translationService.get('lbl_name'),
        width: 250,
      }];
  }

  buildGridOptions(): GridOptions {
    return {
      getRowId: (params) => String(params.data.id),
      rowClassRules: {
        [ROW_DELETED_CLASS]: isInactive,
      },
    };
  }
}
